<template>
<div class="videoList flex_r">
  <div  v-for="(item,index) in videoArr" @click="goInfo(item.id)" :key="index" class="videoItem">
    <!-- <video src=""></video> -->
    <div class="type flex_r">
      <svgIcon v-if="item.type==1" class="f32 marginl4" name='play' />
      <svgIcon v-if="item.type==2" class="f32 marginl4" name='radio' />
      <svgIcon v-if="item.type==3" class="f32 marginl4" name='text' />
      <span v-if="item.type==1" class="marginl4">视频</span>
      <span v-if="item.type==2" class="marginl4">音频</span>
      <span v-if="item.type==3" class="marginl4">文档</span>
    </div>
    <img :src="item.img" alt="cover" class="cover">
    <div class="f18 viewMsg flex_r line25">
      <!-- <svgIcon name='view' /> -->
      <!-- <span>{{item.hits}}</span> -->
      <svgIcon name='view' />
      <span class="marginl4">{{item.hits}}</span>
    </div>
    <div class="content">
      <div class="subtitle f18 cursor fw600 line24 limit2">
        {{item.title}}
      </div>
      <div class="articleTag f16 line24 margint12">
        <span>{{item.job_txt}}</span><span>{{item.topic_txt}}</span>
      </div>
      <div class="line24 f18 flex_r_between fgray margint12">
        <div class="flex_r ellipsis">
          <svgIcon name="location" class="marginr4 flex0" />
          <span class="ellipsis">{{item.province_txt + item.city_txt}}</span>
        </div>
        <div v-if="self" @click.stop="edit(item.id)" class="edit cursor flex0 f18">编辑</div>
        <div v-if="cancelSave" @click.stop="onSave(item.id)" class="edit cursor f18">取消收藏</div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: "myVideo",
  props:{
    videoArr: {
      require: true,
      default: ()=>[]
    },
    self: {
      type: Boolean,
      default: false,
    },
    cancelSave: {
      type: Boolean,
      default: false,
    }
  },
  methods:{
    goInfo(id){
      this.$router.push({
        name:'info',
        params:{
          infoid:id,
        }
      })
    },
    edit(id){
       this.$router.push('/files?id='+id)
    },
    onSave(id){
      this.$emit('onSave',id)
    }
  }
};
</script>
<style lang="less" scoped>
.videoList {
  margin-left: -16px;
  flex-wrap: wrap;
 
}
 .videoItem {
    margin: 0 0 0 16px;
    width: 284px;
    position: relative;
    background: #ffffff;
    border-radius: 4px;
    
    box-sizing: border-box;
    .type{
      position: absolute;
      top: 60px;
      left: 96px;
      width: 92px;
      height: 40px;
      font-size: 20px;
      font-weight: 600;
      color: white;
      background: rgba(0, 0, 0, 0.4);
      border-radius: 20px;
      border: 1px solid rgba(255, 255, 255, 0.3);
    }
    video {
      width: 282px;
      height: 160px;
      background: rgba(0, 0, 0, 0.2);
    }
    .cover{
      width: 282px;
      height: 160px;
      background: rgba(0, 0, 0, 0.2);
    }
    .viewMsg{
      position: absolute;
      left: 8px;
      top: 127px;
      color: white;
    }
    .content {
      padding: 12px 8px;
      box-sizing: border-box;
      .subtitle{
        height: 48px;
        &:hover{
          color: #ad2729;
        }
      }
      .articleTag {
        span {
          margin-right: 4px;
          padding: 0 6px;
          height: 24px;
          border-radius: 4px;
          &:nth-child(1) {
            color: #ffddab;
            background: #ad2729;
          }
          &:nth-child(2) {
            color: #958f8f;
            border: 1px solid #958f8f;
          }
        }
      }
    }
    .edit{
      color: #AD2729;
    }
  }
</style>